import React, { useState } from 'react';
import { Menu, X, Zap, Languages } from 'lucide-react';
interface HeaderProps {
  language: 'en' | 'es';
  setLanguage: (lang: 'en' | 'es') => void;
}
export function Header({
  language,
  setLanguage
}: HeaderProps) {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const content = {
    en: {
      trustBar: 'Over $50M Funded to U.S. Businesses',
      home: 'Home',
      about: 'About',
      apply: 'Apply',
      spanish: 'Español',
      cta1: 'Apply Now',
      cta2: '🇲🇽 Español'
    },
    es: {
      trustBar: 'Más de $50M Financiados a Negocios en EE.UU.',
      home: 'Inicio',
      about: 'Nosotros',
      apply: 'Aplicar',
      spanish: 'English',
      cta1: 'Solicitar Ahora',
      cta2: '🇺🇸 English'
    }
  };
  const t = content[language];
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
      setMobileMenuOpen(false);
    }
  };
  return <>
      {/* Trust Bar */}
      <div className="w-full bg-gradient-to-r from-[#142B44] to-[#2D5D9F] text-white py-2 text-center" data-id="element-80">
        <div className="max-w-7xl mx-auto px-4 flex items-center justify-center space-x-2" data-id="element-81">
          <Zap size={16} className="text-yellow-300 flex-shrink-0" data-id="element-82" />
          <span className="text-xs sm:text-sm font-medium" data-id="element-83">{t.trustBar}</span>
        </div>
      </div>
      <header className="sticky top-0 z-50 bg-white shadow-md" data-id="element-84">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-85">
          <div className="flex justify-between items-center h-20 sm:h-24" data-id="element-86">
            {/* Logo */}
            <button onClick={() => scrollToSection('home')} className="flex items-center space-x-2 hover:opacity-80 transition-opacity" data-id="element-87">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/uLtTqiE6RVpVibQKkcS3sU/unnamed.png" alt="Sparrow Advance" className="h-14 sm:h-16 lg:h-20 w-auto" data-id="element-88" />
            </button>
            {/* Desktop Navigation */}
            <nav className="hidden md:flex items-center space-x-8" data-id="element-89">
              <button onClick={() => scrollToSection('home')} className="text-[#142B44] hover:text-[#2D5D9F] font-medium transition-colors" data-id="element-90">
                {t.home}
              </button>
              <button onClick={() => scrollToSection('about')} className="text-[#142B44] hover:text-[#2D5D9F] font-medium transition-colors" data-id="element-91">
                {t.about}
              </button>
              <button onClick={() => scrollToSection('apply')} className="text-[#142B44] hover:text-[#2D5D9F] font-medium transition-colors" data-id="element-92">
                {t.apply}
              </button>
            </nav>
            {/* CTA Buttons */}
            <div className="hidden md:flex items-center" data-id="element-93">
              <button onClick={() => scrollToSection('apply')} className="px-8 py-3 bg-[#142B44] text-white font-semibold rounded-lg hover:bg-[#2D5D9F] transition-all hover:shadow-lg hover:scale-105 duration-300" data-id="element-94">
                {t.cta1}
              </button>
            </div>
            {/* Mobile Menu Button */}
            <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="md:hidden p-2 text-[#142B44]" data-id="element-95">
              {mobileMenuOpen ? <X size={28} data-id="element-96" /> : <Menu size={28} data-id="element-97" />}
            </button>
          </div>
          {/* Mobile Menu */}
          {mobileMenuOpen && <div className="md:hidden py-4 border-t border-gray-200" data-id="element-98">
              <div className="flex flex-col space-y-4" data-id="element-99">
                <button onClick={() => scrollToSection('home')} className="text-left text-[#142B44] font-medium" data-id="element-100">
                  {t.home}
                </button>
                <button onClick={() => scrollToSection('about')} className="text-left text-[#142B44] font-medium" data-id="element-101">
                  {t.about}
                </button>
                <button onClick={() => scrollToSection('apply')} className="text-left text-[#142B44] font-medium" data-id="element-102">
                  {t.apply}
                </button>
                <button onClick={() => scrollToSection('apply')} className="w-full px-6 py-2.5 bg-[#142B44] text-white font-semibold rounded-lg" data-id="element-103">
                  {t.cta1}
                </button>
                <button onClick={() => setLanguage(language === 'en' ? 'es' : 'en')} className="w-full flex items-center justify-center space-x-2 px-6 py-2.5 bg-gradient-to-r from-[#25D366] to-[#20BA5A] text-white font-semibold rounded-lg" data-id="element-104">
                  <Languages size={18} data-id="element-105" />
                  <span data-id="element-106">{t.cta2}</span>
                </button>
              </div>
            </div>}
        </div>
      </header>
    </>;
}